export const apiCall = (link) => fetch(link).then(response => response.json())



// WEBPACK FOOTER //
// ./src/api/api.js